import { useEffect, useMemo, useState } from 'react'
import { useAppDispatch, useAppSelector } from 'Store/selectors'
import {
  getAllAutoParts,
  getAllCities,
  GetAllWithVehicleTypes,
  getAllStates,
  getAllVehicleAccessories,
  getAllVehicleBrands,
  getAllVehicleColors,
  getAllVehicleTips,
  getAllVehicleTypes,
  getAllVehicleUsages,
  getVehicleOptions,
  getVehicleVisitingPoints,
  GetAllPlateSerial,
  GetAllCountry,
} from 'Application/Visits/Actions/action'
import {
  useLazyGenerateAllAudiosQuery,
  useLazyGetAllAccessListQuery,
  useLazyGetInsuranceExpertFieldsCurrentUserQuery,
  useLazyGetUserProfileQuery,
} from 'Services/api'

const useInitializer = () => {
  const [initializerLoading, setInitializerLoading] = useState(false)
  const [initializerLoaded, setInitializerLoaded] = useState<boolean | undefined>(undefined)

  const [triggerUserProfile, userProfileQuery] = useLazyGetUserProfileQuery()
  const [triggerAccessList, accessListQuery] = useLazyGetAllAccessListQuery()
  const [triggerExpertFields, expertFieldsQuery] = useLazyGetInsuranceExpertFieldsCurrentUserQuery()
  // const [triggerNotigication, notificationQuery] = useLazyGetUserNotificationPagedFilterDIPQuery()
  const [triggerTts] = useLazyGenerateAllAudiosQuery()

  const visits = useAppSelector(store => store.visits)

  const {
    vehicleVisitingPoints: {
      data: visitingPoints,
      vehicleVisitingPointsLoading,
      vehicleVisitingPointsLoaded,
    },
    vehicleOptionList: { vehicleOptionsLoading, vehicleOptionsLoaded },
    autoParts: { autoPartsLoading, autoPartsLoaded },
    vehicleAccessories: { vehicleAccessoriesLoading, vehicleAccessoriesLoaded },
    vehicleTypes: { vehicleTypesLoading, vehicleTypesLoaded },
    vehicleUsages: { vehicleUsagesLoading, vehicleUsagesLoaded },
    vehicleBrands: { vehicleBrandsLoading, vehicleBrandsLoaded },
    vehicleTips: { vehicleTipsLoading, vehicleTipsLoaded },
    vehicleColors: { vehicleColorsLoading, vehicleColorsLoaded },
    states: { statesLoading, statesLoaded },
    cities: { citiesLoading, citiesLoaded },
    cargoRoom: { cargoroomLoading, cargoRoomLoaded },
    freeZone: { freeZoneLoading, freeZoneLoaded },
    CountryList: { lCountrysLoading, lCountrysLoaded },
  } = visits

  const dispatch = useAppDispatch()

  const initialize = () => {
    triggerAccessList()
    triggerUserProfile()
    triggerExpertFields()
    // triggerNotigication()

    dispatch(getVehicleVisitingPoints())
    dispatch(getVehicleOptions())
    dispatch(getAllAutoParts())
    dispatch(getAllVehicleAccessories())
    dispatch(getAllVehicleTypes())
    dispatch(getAllVehicleUsages())
    dispatch(getAllVehicleBrands())
    dispatch(getAllVehicleTips())
    dispatch(getAllVehicleColors())
    dispatch(getAllStates())
    dispatch(getAllCities())
    dispatch(GetAllWithVehicleTypes())
    dispatch(GetAllPlateSerial())
    dispatch(GetAllCountry())
  }

  useEffect(() => {
    if (!visitingPoints?.length) return

    const inputs = visitingPoints.map(point => point.label)

    triggerTts({ inputs })
  }, [visitingPoints])

  const isLoading = useMemo(
    () =>
      [
        accessListQuery.isLoading,
        userProfileQuery.isLoading,
        expertFieldsQuery.isLoading,
        // notificationQuery.isLoading,
        vehicleVisitingPointsLoading,
        vehicleOptionsLoading,
        autoPartsLoading,
        vehicleAccessoriesLoading,
        vehicleTypesLoading,
        vehicleUsagesLoading,
        vehicleBrandsLoading,
        vehicleTipsLoading,
        vehicleColorsLoading,
        statesLoading,
        citiesLoading,
        cargoroomLoading,
        freeZoneLoading,
        lCountrysLoading,
      ].some(Boolean),
    [
      accessListQuery.isLoading,
      userProfileQuery.isLoading,
      expertFieldsQuery.isLoading,
      // notificationQuery.isLoading,
      vehicleVisitingPointsLoading,
      vehicleOptionsLoading,
      autoPartsLoading,
      vehicleAccessoriesLoading,
      vehicleTypesLoading,
      vehicleUsagesLoading,
      vehicleBrandsLoading,
      vehicleTipsLoading,
      vehicleColorsLoading,
      statesLoading,
      citiesLoading,
      cargoroomLoading,
      freeZoneLoading,
      lCountrysLoading,
    ],
  )

  useEffect(() => {
    setInitializerLoading(isLoading)
  }, [isLoading])

  const isLoaded = useMemo(() => {
    const loadedFlags = [
      accessListQuery.isSuccess,
      userProfileQuery.isSuccess,
      expertFieldsQuery.isSuccess,
      // notificationQuery.isSuccess,
      vehicleVisitingPointsLoaded,
      vehicleOptionsLoaded,
      autoPartsLoaded,
      vehicleAccessoriesLoaded,
      vehicleTypesLoaded,
      vehicleUsagesLoaded,
      vehicleBrandsLoaded,
      vehicleTipsLoaded,
      vehicleColorsLoaded,
      statesLoaded,
      citiesLoaded,
      cargoRoomLoaded,
      freeZoneLoaded,
      lCountrysLoaded,
    ]

    if (loadedFlags.some(v => v === undefined)) return undefined
    return loadedFlags.every(Boolean)
  }, [
    accessListQuery.isSuccess,
    userProfileQuery.isSuccess,
    expertFieldsQuery.isSuccess,
    // notificationQuery.isSuccess,
    vehicleVisitingPointsLoaded,
    vehicleOptionsLoaded,
    autoPartsLoaded,
    vehicleAccessoriesLoaded,
    vehicleTypesLoaded,
    vehicleUsagesLoaded,
    vehicleBrandsLoaded,
    vehicleTipsLoaded,
    vehicleColorsLoaded,
    statesLoaded,
    citiesLoaded,
    cargoRoomLoaded,
    freeZoneLoaded,
    lCountrysLoaded,
  ])

  useEffect(() => {
    setInitializerLoaded(isLoaded)
  }, [isLoaded])

  return { initialize, initializerLoading, initializerLoaded, userProfileState: userProfileQuery }
}
export default useInitializer
